import React, { useEffect } from 'react';
import { Col, Card, Row, Button } from 'reactstrap';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { partial } from '../../../util/translation/translation';
import renderField from '../../../shared/components/custom/Field';
import TierCardPreview from './TierCardPreview';
import validate from './validate';
import renderDropZoneField from '../../../shared/components/form/DropZoneMS';
import TextEditor2 from '../../../shared/components/text-editor/TextEditor2';
import renderRadioButtonField from '../../../shared/components/form/RadioButton';
import TooltipWithIcon from '../../../shared/components/custom/TooltipWithIcon';
import renderSwitchField from '../../../shared/components/custom/Switch';
import FormBox from '../../../shared/components/custom/FormBox';

const s = partial('shared');
const p = partial('UserTiers');

const UserTierForm = ({ handleSubmit, tier, initialize, formValues }) => {
  useEffect(() => {
    if (tier) {
      const {
        createdAt,
        updatedAt,
        deletedAt,
        originalUrl,
        features,
        cardUrl,
        prices,
        description,
        ...tierValues
      } = tier;

      const initObject = {
        ...tierValues,
        description,
        image: originalUrl
          ? {
              name: 'image',
              preview: originalUrl,
            }
          : null,
        cardBackground: cardUrl
          ? {
              name: 'image',
              preview: cardUrl,
            }
          : null,

        pickedFeatures: features,
        salesDescription: tier.salesDescription,
        forSale: tier.forSale,
        visible: tier.visible,
        sharable: tier.sharable,
        sharedViaApi: !!tier.sharedViaApi,
        visiblePrice: tier.visiblePrice,
      };
      let completeObject = { ...initObject };
      if (prices.length) {
        completeObject = {
          ...completeObject,
          ...{
            price1: prices[0],
            // price3: prices[1],
            // price6: prices[2],
            price12: prices[3],
          },
        };
      }
      initialize(completeObject);
    }
  }, [tier]);

  return (
    <form className="form" onSubmit={handleSubmit}>
      <Card>
        <Row>
          <Col lg={7} md={12} sm={12} xs={12}>
            <Row>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div className="form__form-group">
                  <span className="form-header">{p('tierName')}</span>
                  <div className="marginTop-5" />
                  <Field
                    name="name"
                    disabled={tier?.name}
                    component={renderField}
                    placeholder={p('tierName')}
                  />
                </div>
              </Col>
              <Col lg={6} md={12} sm={12} xs={12}>
                <div className="form__form-group">
                  <span className="form-header">
                    {p('tierIcon')} (200px/200px)
                  </span>
                  <Field
                    name="image"
                    component={renderDropZoneField}
                    crop="TIER_CROP"
                  />
                </div>
              </Col>
              <Col lg={6} md={12} sm={12} xs={12}>
                <div className="form__form-group">
                  <span className="form-header">
                    {p('cardBackground')} (16/9)
                  </span>
                  <Field
                    name="cardBackground"
                    component={renderDropZoneField}
                    crop="LANDSCAPE"
                  />
                </div>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12} className="mb-2">
                <FormBox title={'App'}>
                  <Col>
                    <span className="form">
                      {p('visible')}
                      &nbsp;
                      <TooltipWithIcon
                        id="no-access-view-tooltip2"
                        text={p('visibleInfo')}
                      />
                    </span>
                    <div className="form__form-group-field">
                      <div className="form__form-group">
                        <Field
                          name="visible"
                          component={renderSwitchField}
                          label={[p('visible'), p('notVisible')]}
                          className="colored-click"
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <div className="form__form-group">
                      <span className="form-header">{s('description')}</span>
                      <div className="marginTop-5" />
                      <div className="form__form-group form__form-group-id">
                        <Field name="description" component={TextEditor2} />
                      </div>
                    </div>
                  </Col>
                  <Col>
                    <span className="form">
                      {p('sharable')}
                      &nbsp;
                      <TooltipWithIcon
                        id="no-access-view-tooltip3"
                        text={p('sharableInfo')}
                      />
                    </span>
                    <div className="form__form-group-field">
                      <div className="form__form-group">
                        <Field
                          name="sharable"
                          disabled
                          component={renderSwitchField}
                          label={[p('sharable'), p('notSharable')]}
                          className="colored-click"
                        />
                      </div>
                    </div>
                  </Col>
                </FormBox>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12} className="mb-2">
                <Col>
                  <span className="form">
                    {p('sharedViaApi')}
                    &nbsp;
                    <TooltipWithIcon
                      id="tier-shared-via-api-tooltip"
                      text={p('sharedViaApiInfo')}
                    />
                  </span>
                  <div className="form__form-group-field">
                    <div className="form__form-group">
                      <Field
                        name="sharedViaApi"
                        component={renderSwitchField}
                        label={[p('sharedViaApiOn'), p('sharedViaApiOff')]}
                        className="colored-click"
                      />
                    </div>
                  </div>
                </Col>
              </Col>
            </Row>
          </Col>
          <Col lg={5} md={12} sm={12} xs={12}>
            <Row>
              <Col className="ml-3">
                <span className="form-header">App preview</span>
                <TierCardPreview
                  name={formValues?.name}
                  background={
                    formValues?.cardBackground?.croppedImage ||
                    formValues?.cardBackground?.preview
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col md={12} style={{ marginTop: '15px' }}>
            <Button type="submit" color="primary">
              {s('save')}
            </Button>
            <Link className="color-unset" to="/user_tiers">
              <Button type="button">{s('close')}</Button>
            </Link>
          </Col>
        </Row>
      </Card>
    </form>
  );
};
const reduxF = reduxForm({
  form: 'user-tier-form',
  validate,
});
const mapStateToProps = (state) => ({
  formValues: getFormValues('user-tier-form')(state),
});

export default connect(mapStateToProps)(reduxF(UserTierForm));
